/* eslint-disable react/jsx-key */
import { Path } from '@vimeo/iris/components';
import { Header, Link, Paragraph } from '@vimeo/iris/typography';

import GuideTable from 'src/_components/GuideTable';
import GuideWrapper from 'src/_components/GuideWrapper';
import Meta from 'src/_components/Meta';
import StyledNotice from 'src/_components/StyledNotice';

import SDKS from '../libraries/sdks.json';

export default function LegacyLibraries() {
  const LibraryPlatform = (props) => {
    const { platform, packages, description } = props;
    const androidDeepLinkDescription = (
      <Paragraph size="2">
        This helper library is for deep linking into the official{' '}
        <Link
          variant="minimal"
          href="https://play.google.com/store/apps/details?id=com.vimeo.android.videoapp"
        >
          Vimeo mobile app
        </Link>{' '}
        for Android.
      </Paragraph>
    );
    const androidNote = (
      <StyledNotice>
        <strong>NOTE:</strong> For information about current Android libraries, see the{' '}
        <Link variant="minimal" href="/api/libraries#andriod libraries">
          {' '}
          Android section of Libraries and SDKs
        </Link>
        .
      </StyledNotice>
    );

    return (
      <div>
        <Header size="3" id={platform.toLowerCase()}>
          {platform}
        </Header>
        {description && <Paragraph size="2">{description}</Paragraph>}

        <GuideTable
          headers={['GiHub repository', 'Description']}
          rows={Object.keys(packages).map(function (pkg) {
            return [
              <code>
                <Link variant="minimal" href={packages[pkg].code} target="_blank">
                  {packages[pkg].project.toLowerCase()}
                </Link>
              </code>,

              <div>
                <p>
                  {packages[pkg].author ? (
                    <Paragraph size="2">
                      {packages[pkg].description} The owner is{' '}
                      <Link variant="minimal" href={packages[pkg].author_link} target="_blank">
                        {packages[pkg].author}
                      </Link>
                    </Paragraph>
                  ) : (
                    <Paragraph size="2">{packages[pkg].description}</Paragraph>
                  )}
                  {packages[pkg].project === 'vimeo/vimeo-deeplink-android' &&
                    androidDeepLinkDescription}
                </p>
              </div>,
            ];
          })}
        />
        {platform === 'Legacy Android libraries' && androidNote}
      </div>
    );
  };

  return (
    <>
      <Meta
        title="Vimeo API Legacy Libraries and SDKs"
        description="Find links to Vimeo API legacy libraries and SDKs for iOS and Android."
      />
      <GuideWrapper
        breadcrumbs={
          <Path>
            <Path.Link href={'/'}>Home</Path.Link>
            <Path.Link href={'/api/guides/start'}>API</Path.Link>
            <Path.Current>Legacy Libraries and SDKs</Path.Current>
          </Path>
        }
        nav={{ page: 'legacy-libraries' }}
      >
        <div>
          <div>
            <Header>Legacy Libraries and SDKs</Header>

            <Paragraph size="2">
              Welcome to the Legacy Libraries and SDKs page, where you’ll find all things library
              and SDK from back in the day. While the official libraries on this page are still
              accessible and may serve as a useful starting point, they are no longer supported by
              Vimeo staff.
            </Paragraph>

            <StyledNotice>
              <strong>NOTE:</strong> For information about current libraries and SDKs, see{' '}
              <Link variant="minimal" href="/api/libraries">
                {' '}
                Libraries and SDKs
              </Link>
              .
            </StyledNotice>

            {Object.keys(SDKS.legacy).map(function (lib, i) {
              return (
                <LibraryPlatform
                  key={`libraries-legacy-${i}`}
                  platform={SDKS.legacy[lib].platform}
                  packages={SDKS.legacy[lib].packages}
                  description={SDKS.legacy[lib].description}
                />
              );
            })}
          </div>
        </div>
      </GuideWrapper>
    </>
  );
}
